<template>
  <div :class="$style.container" v-if="invitations">
    <div :class="$style.titleSection">
      <div :class="$style.title">DATA COLLECTOR INVITATION STATUS</div>
      <button @click="handleNavigate" class="button" :class="$style.button">
        <span>Go to Participants</span>
        <span class="icon">
          <i class="fas fa-chevron-right"></i>
        </span>
      </button>
    </div>

    <p-data-table
      :data="invitations"
      :hoverable="true"
      :noDataText="`No invitation found`"
    >
      <template slot="thead">
        <tr>
          <td width="20%">Email</td>
          <td width="20%">Role</td>
          <td width="20%">Site(s)</td>
          <td width="20%">Last Invited</td>
          <td width="20%">Status</td>
        </tr>
      </template>
      <!-- TODO-PAC-924 Check with client for UI team and client for the better design -->
      <template slot="tbody" slot-scope="{ data }">
        <tr v-for="item in data" :key="item.id">
          <td>{{ item.userEmail }}</td>
          <td>{{ item.participantRole }}</td>
          <td>
            <ul style="list-style: disc">
              <li
                v-for="(site, index) in item.participantSites"
                :key="`${site}_${index}`"
              >
                {{ site }}
              </li>
            </ul>
          </td>
          <td>{{ invitationDate(item.token) }}</td>
          <td>{{ invitationStatus(item.token) }}</td>
        </tr>
      </template>
    </p-data-table>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  InvitationToken,
  ParticipantInvitation,
  ParticipantInvitationListDTO,
} from '../../../store/modules/projects/types/projects.types';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../../utils/date.util';
import { AuditSite } from '@/store/modules/audits/types/audits.types';

@Component({
  components: {},
})
export default class AuditInvitationList extends Vue {
  @Prop() public participantInvitations!: ParticipantInvitation[];
  @Prop() public auditSites!: AuditSite[];

  get invitations() {
    if (this.participantInvitations) {
      const data: ParticipantInvitationListDTO[] = this.participantInvitations.map(
        (invitation: ParticipantInvitation) => {
          return {
            userEmail: invitation.invitationToken.email,
            participantRole: invitation.role,
            participantSites: this.siteNames(invitation.siteIds),
            token: invitation.invitationToken,
          };
        },
      );

      return data.slice(0, 5);
    }
    return [];
  }

  public siteNames(siteIds: number[]): string[] {
    return this.auditSites
      .filter((as) => siteIds.includes(as.site.id))
      .map((as) => as.site.name);
  }

  get dayjs() {
    return dayjs;
  }

  public invitationDate(item: InvitationToken): string | null {
    return dayjs(item.updatedAt || item.createdAt).format(DATE_FORMAT) || null;
  }

  public invitationStatus(invitation: InvitationToken) {
    if (invitation.acceptedAt) {
      return 'Accepted';
    }

    if (new Date(invitation.expiredAt) <= new Date()) {
      return 'Expired';
    } else {
      return 'Pending';
    }
  }

  public handleNavigate() {
    this.$emit('changeActiveTab', '#participants');
  }
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 5rem;

  .titleSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: bold;
      text-transform: uppercase;
      padding: 8px;
    }

    .button {
      border: none;
      background: transparent;
      color: $primary;
    }
  }
}
</style>
